<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("IMPORTS.EDIT_IMPORT") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <import-form
              :loading="loading"
              :importData="importation"
              :formErrors="formErrors"
              @importSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import ImportForm from "@/views/Pages/AdminModule/ImportModule/Partials/ImportForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultImport from "./defaultImport";

export default {
  layout: "DashboardLayout",

  components: { ImportForm },

  mixins: [alertLeave],

  data() {
    return {
      importation: cloneDeep(defaultImport),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("imports/get", id);
        this.importation = this.$store.getters["imports/import"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Imports" });
    },

    viewImport() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Imports",
        params: { id: this.importation.id },
      });
    },

    async handleSubmit(importation) {
      this.loading = true;
      const importationData = cloneDeep(importation);

      try {
        await this.$store.dispatch("imports/update", importationData);
        this.$notify({
          type: "success",
          message: this.$t("IMPORTS.IMPORT_UPDATED"),
        });
        this.viewImport();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
